module.exports = __webpack_public_path__ + "static/mh-task2-c95b219f7ed15e4a257c4cdaa7cf2fcd.png";